import { render } from "./Footer_m.vue?vue&type=template&id=287c2ff3"
import script from "./Footer_m.vue?vue&type=script&lang=js"
export * from "./Footer_m.vue?vue&type=script&lang=js"

import "./Footer_m.vue?vue&type=style&index=0&id=287c2ff3&lang=css"
script.render = render

export default script